import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpUpdateRoadmapActivity } from '@/features/roadmaps/http/roadmap.http'
import type {
	HttpUpdateRoadmapActivityPayload,
	RoadmapActivity
} from '@/features/roadmaps/types'
import { MUTATION_KEYS, QUERY_KEYS } from '@/query-client'

interface UseUpdateRoadmapActivityProps {
	onSuccess?: (data: RoadmapActivity) => void
	onError?: (error: unknown) => void
}

export const useUpdateRoadmapActivity = (
	options?: UseUpdateRoadmapActivityProps
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [MUTATION_KEYS.UPDATE_ROADMAP_ACTIVITY],
		mutationFn: (payload: HttpUpdateRoadmapActivityPayload) =>
			httpUpdateRoadmapActivity(payload),
		onError: (error) => options?.onError?.(error),
		onSuccess: (data) => {
			// An edit can move a bar out of the window it was fetched for, so
			// every cached range is refetched rather than patched in place.
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_ROADMAP_ACTIVITIES]
			})
			options?.onSuccess?.(data)
		}
	})
}
